const config = {
    server: 'http://127.0.0.1:5000',
    dateFormat: "el-GR"
}

if (!process.env.NODE_ENV || process.env.NODE_ENV !== 'development') {
    config.server = "https://api.thesisgate.net";
}

export default config;